const INITIAL_PAGES = [1]
const INITIAL_PER_PAGE_VARIANTS = [5, 10, 25, 50, 100]
const INITIAL_PAGINATION = {
  page: INITIAL_PAGES[0],
  perPage: INITIAL_PER_PAGE_VARIANTS[2],
  totalCount: 0,
  totalPages: 0,
}
const INITIAL_PER_PAGE_BIG_VARIANTS = [25, 50, 75]
const INITIAL_PER_PAGE_VARIANTS_MULTIPLE_THREE = [9, 15, 30, 60]
const EXTENDED_PER_PAGE_VARIANTS = [10, 20, 30, 40, 50, 100, 200, 300, 400, 500]

export {
  EXTENDED_PER_PAGE_VARIANTS,
  INITIAL_PAGES,
  INITIAL_PAGINATION,
  INITIAL_PER_PAGE_BIG_VARIANTS,
  INITIAL_PER_PAGE_VARIANTS,
  INITIAL_PER_PAGE_VARIANTS_MULTIPLE_THREE,
}
